<template>
  <div class="game">
    <template v-if="gameId">
      <ActiveIndividualGame :playerKey="playerKey" :gameId="gameId" />
    </template>
    <template v-if="error">
      <div class="text-center">
        Game Not Found
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import ActiveIndividualGame from "@/components/ActiveIndividualGame.vue";
import refs from "@/components/firebase/refs";
import join_game from "@/components/firebase/join_game";

export default {
  name: "Home",
  props: {
    gameName: String,
    gameId: String,
    playerKey: String,
  },
  components: {
    ActiveIndividualGame,
  },
  async created() {
    console.log("individual game playerKey", this.playerKey);
    console.log("individual game gameName", this.gameName);
    await join_game.authorize();
    await this.resolveGameId();

    if (!this.gameId) {
      this.error = true;
      console.log("game does not exist");
    }
  },
  methods: {
    async resolveGameId() {
      var snap = await refs.gameId(this.gameName).once("value");
      if (snap == null || snap.val() == null) {
        return;
      }
      console.log("snap", snap.val());
      this.gameId = snap.val().gameId;
    },
  },
  data() {
    return {
      error: false,
      view: this.playerKey ? "game" : "join",
      name: "",
    };
  },
};
</script>
